module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-144x144-cd0ff13056847c28cdefddaad64f4ac5.png";